export const useApi = async (url, options = {}) => {
  const config = useRuntimeConfig()
  const baseURL = config.public.BASE_URL

  try {
    const token = import.meta.client ? localStorage.getItem('token') : null

    const response = await $fetch(url, {
      baseURL,
      method: options.method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
      },
      body: options.body,
      throwOnError: true,
      ...options,
    })

    return response
  } catch (error) {
    if (error?.response?.status === 401 && import.meta.client) {
      localStorage.removeItem('token')
      navigateTo('/login')
    }

    throw error
  }
}
